import { __awaiter, __generator } from "tslib";
import { NetworkError } from '@/core/Types/error';
import { baseVersion } from '@/constants';
import { severErrors } from '@/core/standard/constants';

var BaseRepository =
/** @class */
function () {
  function BaseRepository(obj) {
    this.useAuth = true;
    this.collection = '';
    this.headers = {
      'Site': location.origin,
      'Client': 'web',
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Accept-language': 'es'
    };
    this.version = baseVersion;
    this.provider = obj;
  } // // Métodos Predefinidos


  BaseRepository.prototype.getAll = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, url, headers, response, e_1;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.generateOptionObject(params), url = _a.url, headers = _a.headers;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.provider.get(url, {
              params: params.query,
              headers: headers
            })];

          case 2:
            response = _b.sent().data;
            return [2
            /*return*/
            , response];

          case 3:
            e_1 = _b.sent();
            return [2
            /*return*/
            , this.handleError(e_1)];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseRepository.prototype.getBy = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, url, headers, response, e_2;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.generateOptionObject(params), url = _a.url, headers = _a.headers;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.provider.get(url, {
              params: params.query,
              headers: headers
            })];

          case 2:
            response = _b.sent().data;
            return [2
            /*return*/
            , response];

          case 3:
            e_2 = _b.sent();
            return [2
            /*return*/
            , this.handleError(e_2)];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseRepository.prototype.deleteBy = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, url, headers, response, e_3;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.generateOptionObject(params), url = _a.url, headers = _a.headers;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.provider.delete(url, {
              params: params.query,
              headers: headers
            })];

          case 2:
            response = _b.sent().data;
            return [2
            /*return*/
            , response];

          case 3:
            e_3 = _b.sent();
            return [2
            /*return*/
            , this.handleError(e_3)];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }; // For soft Delete


  BaseRepository.prototype.restoreBy = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, url, headers, response, e_4;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.generateOptionObject(params), url = _a.url, headers = _a.headers;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.provider.delete(url, {
              params: params.query,
              headers: headers
            })];

          case 2:
            response = _b.sent().data;
            return [2
            /*return*/
            , response];

          case 3:
            e_4 = _b.sent();
            return [2
            /*return*/
            , this.handleError(e_4)];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseRepository.prototype.batchDelete = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, url, headers, response, e_5;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.generateOptionObject(params), url = _a.url, headers = _a.headers;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.provider.delete(url, {
              params: params.query,
              headers: headers
            })];

          case 2:
            response = _b.sent().data;
            return [2
            /*return*/
            , response];

          case 3:
            e_5 = _b.sent();
            return [2
            /*return*/
            , this.handleError(e_5)];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseRepository.prototype.insert = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, url, headers, response, e_6;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.generateOptionObject(params), url = _a.url, headers = _a.headers;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.provider.post(url, params.query, {
              headers: headers
            })];

          case 2:
            response = _b.sent().data;
            return [2
            /*return*/
            , response];

          case 3:
            e_6 = _b.sent();
            return [2
            /*return*/
            , this.handleError(e_6)];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseRepository.prototype.update = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, url, headers, response, e_7;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.generateOptionObject(params), url = _a.url, headers = _a.headers;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.provider.put(url, params.query, {
              headers: headers
            })];

          case 2:
            response = _b.sent().data;
            return [2
            /*return*/
            , response];

          case 3:
            e_7 = _b.sent();
            return [2
            /*return*/
            , this.handleError(e_7)];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }; // For compatibility reasons with older api version


  BaseRepository.prototype.request = function (parameters) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, url, headers, responseType, config, response, e_8;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.generateOptionObject(parameters), url = _a.url, headers = _a.headers, responseType = _a.responseType;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            config = {
              url: url,
              headers: headers,
              responseType: responseType,
              method: parameters.method,
              data: parameters.query
            }; // tslint:disable-next-line:max-line-length

            if (parameters.method === 'GET' || parameters.method === 'get' || parameters.method === 'DELETE' || parameters.method === 'delete') {
              config.params = parameters.query;
            }

            return [4
            /*yield*/
            , this.provider.request(config)];

          case 2:
            response = _b.sent().data;
            return [2
            /*return*/
            , response];

          case 3:
            e_8 = _b.sent();
            return [2
            /*return*/
            , this.handleError(e_8)];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseRepository.prototype.generateFinalURL = function (id, url, version) {
    if (version === void 0) {
      version = this.version;
    }

    var finalURL = version ? version + "/" + this.collection + "/" : this.collection + "/";

    if (id) {
      finalURL += id + "/";
      finalURL += url ? url + "/" : '';
    } else {
      if (url) {
        finalURL += url + "/";
      }
    }

    this.provider.defaults.paramsSerializer = this.param2query;
    return finalURL;
  };

  BaseRepository.prototype.param2query = function (params) {
    var base64 = btoa(JSON.stringify(params));
    return "q=" + base64; // return Object.entries(params).map(([key, value]) => `${key}=${value.toString()}`).join('&');
  };

  BaseRepository.prototype.handleError = function (e) {
    if (e.response) {
      return new severErrors[e.response.status](e.response.data);
    } else if (e.request) {
      return new NetworkError(e.request);
    } else {
      throw new Error('Something happened while configuring urls please check config status');
    }
  };

  BaseRepository.prototype.generateOptionObject = function (_a) {
    var url = _a.url,
        version = _a.version,
        id = _a.id,
        headers = _a.headers,
        useAuth = _a.useAuth,
        responseType = _a.responseType;
    var token = this.needsAuth(useAuth);
    var finalURL = this.generateFinalURL(id, url, version);
    var finalHeaders = this.generateFinalHeaders(headers, token);
    return {
      url: finalURL,
      headers: finalHeaders,
      responseType: responseType || 'json'
    };
  };

  BaseRepository.prototype.needsAuth = function (useAuth) {
    if (useAuth === void 0) {
      useAuth = this.useAuth;
    }

    var _a;

    var local = (_a = localStorage.getItem('token')) === null || _a === void 0 ? void 0 : _a.trim();

    if (local && useAuth) {
      return local;
    }

    return false;
  };

  BaseRepository.prototype.generateFinalHeaders = function (headers, auth) {
    if (headers === void 0) {
      headers = {};
    }

    var TPV = localStorage.getItem('tpv');
    var baseHeaders = Object.assign({}, this.headers);

    if (TPV) {
      baseHeaders.TPV = TPV;
    }

    if (!!auth) {
      baseHeaders.Authorization = auth;
    } else {
      if ('Authorization' in baseHeaders) {
        delete baseHeaders.Authorization;
      }
    }

    return Object.assign(baseHeaders, headers);
  };

  return BaseRepository;
}();

export default BaseRepository;